import { Outlet } from "react-router-dom";

export const SupportLayout = () => {
	return <Outlet />;
};
